export class OnboardOTP {
  Slug: string;
  OTPCode: string;
}
